<template>
    <div class="wf-page">
        <Search :showAdd="showAdd" :showDownload="showDownload" :downloadText="downloadText" :showAddText="showAddText" :searchData="searchData" :renderList="renderSearchList" @change="handleChangeSearchData" @search="handleSearch" @add="handleAdd" @download="handleDownload"></Search>
        <div class="wf-page-search-mobile">

        </div>
        <div class="wf-page-content">
            <slot></slot>
        </div>
        <div class="wf-page-bottom">
            <div class="wf-page-pageInfo">
                <span class="wf-page-total">共{{total | filterTotal}}条记录</span>
                <div class="wf-page-pageSize">
                    <Select :options="options" :clearable="false" :value="pageSize" @change="handlePageSizeChange"></Select>
                </div>
            </div>
            <Page :current="current" :total="total" :page-size="pageSize" show-elevator @on-change="handleChangeCurrent"></Page>
        </div>
    </div>
</template>

<script>
import Search from '@/components/search/search.vue'
import Table from 'iview/src/components/table';
import Icon from 'iview/src/components/icon';
import Page from 'iview/src/components/page';
import Select from '@/components/select/select.vue'

export default {
    components: {
        Search,
        Table,
        Page,
        Select,
        Icon
    },
    data() {
        return {
            options: [
                {
                    label: '15条/页',
                    value: 15
                },
                {
                    label: '30条/页',
                    value: 30
                },
                {
                    label: '50条/页',
                    value: 50
                }
            ]
        }
    },
    filters: {
        // 过滤记录条数
        filterTotal(number) {
            return number || 0
        }
    },
    mounted() {
    },
    props: {
        renderSearchList: {
            type: Array,
            default: () => {
                return []
            }
        },
        tableData: {
            type: Array,
            default: () => {
                return []
            }
        },
        searchData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        total: {
            type: Number,
            default: 0
        },
        current: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 15
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        showAddText: {
            type: String,
            default: ""
        },
        showDownload: {
			type: Boolean,
			default: false
		},
		downloadText: {
			type: String,
			default: ""
		}
    },
    methods: {
        // 处理改变当前页事件
        handleChangeCurrent(current) {
            this.$emit('changeCurrrent', current)
        },

        // 处理pageSize改变事件
        handlePageSizeChange(pageSize) {
            this.$emit('changePageSize', pageSize)
        },

        // 处理输入框内容改变时触发
        handleChangeSearchData(eventData) {
            this.$emit('changeSearchDat', eventData)
        },

        // 处理搜索时触发
        handleSearch() {
            this.$emit('search')
        },

        // 处理点击新增
        handleAdd() {
            this.$emit('add')
        },

        // 处理点击下载
        handleDownload() {
            this.$emit('download')
        }
    }
}
</script>

<style lang="scss" scoped>
.wf-page {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    .wf-page-search-mobile {
        display: none;
    }
    .wf-page-content {
        flex: 1;
        padding-bottom: 50px;;
        /deep/ .ivu-table-wrapper {
			border-color: #fff;
            .ivu-table {
                .ivu-table-header {
                    th{
                        background-color: #f6efed;
                    }
                }
                th,
                td {
                    border-bottom-color: #fff;
                }
				th {
					height: 48px;
				}
            }
            .ivu-table-cell {
                padding-left: 8px;
                padding-right: 8px;
            }
			.ivu-table:after {
				display: none;
			}
			.ivu-table::before {
				background-color: #F6EFED;
			}
			.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td {
				background: #F9F6F5;
			}
			.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td {
				background: #ebf7ff;
			}
        }
    }
    .wf-page-bottom {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        .wf-page-pageInfo {
            display: flex;
            flex-direction: row;
            align-items: center;
            .wf-page-total {
                font-size: 12px;
                color: #999999;
            }
            .wf-page-pageSize {
                margin-left: 10px;
                width: 81px;
                /deep/ .ivu-select-input {
                    height: 24px;
                }
                /deep/ .ivu-select-selection {
                    height: 26px;
                    border-radius: 0;
                }
                /deep/ .ivu-select-placeholder {
                    height: 24px;
                    line-height: 24px;
                }
            }
        }
        /deep/ .ivu-page-item-active {
            background-color: #0061E4;
            border-color: #0061E4;
        }
        /deep/ .ivu-page {
            > li {
                min-width: 26px;
                height: 26px;
                line-height: 24px;
            }
            .ivu-page-item:hover {
                border-color: #dddee1;
                a {
                    color: #495060;
                }
            }
            .ivu-page-item-active:hover {
                a {
                    color: #fff;
                }
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/components/page/page.vue